import { render, staticRenderFns } from "./ModuleVimeoForm.vue?vue&type=template&id=5be7c4b5&scoped=true"
import script from "./ModuleVimeoForm.vue?vue&type=script&lang=js"
export * from "./ModuleVimeoForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleVimeoForm.vue?vue&type=style&index=0&id=5be7c4b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7c4b5",
  null
  
)

export default component.exports